export function markResponseHref(responseId: number, markId: number | undefined): string {
  return `/marking/mark-response/${responseId}${markId ? `?markId=${markId}` : ''}`;
}

export function markingGroupHref(groupId: number): string {
  return `/marking/marking-groups/${groupId}`;
}
